import React, {useEffect, useRef, useState} from "react"
import {
    Card,
    Drawer,
    fixed2Digit,
    Form,
    HyperLink,
    InputBox,
    notification
} from "../../../components/Elements/appUtils";
import {GetEachFormFields} from "../../../components/_utils/formUtils";
import {PaymentTypes} from "../../../components/_utils/appUtils";
import {getItemLocalstorage} from "../../../components/_utils/_utils";
import {useDispatch} from "react-redux";
import {fetchBank} from "../../customer/actions";
import moment from "moment";
import {addPaymentInDirectFxn} from "../../customer/actions/patients";

const PaymentInDrawer = (props) => {
    let {form, visible, onClose, onSubmit, saleId, customer} = props
    const checkUserType = getItemLocalstorage("user")["userType"];
    const [formData, setFormData] = useState([
        {bankId: "", paymentType: "", amount: "", transactionDetails: ""},
    ]);
    const [showDeleteButtons, setShowDeleteButtons] = useState([false]);

    const handleInputChange = (index, field, value) => {
        const newData = [...formData];
        newData[index][field] = value;
        setFormData(newData);
        setShowDeleteButtons((prevButtons) =>
            prevButtons?.map((btn, idx) => (idx === index ? true : btn))
        );
    };

    const handleDelete = (index) => {
        const newPayments = [...formData];
        newPayments.splice(index, 1);
        setFormData(newPayments);
        setShowDeleteButtons((prevButtons) =>
            prevButtons?.filter((_, idx) => idx !== index)
        );
    };

    const {getFieldValue} = form;
    let dispatch = useDispatch();
    const [banks, setBanks] = useState([]);
    const [ProductReport, setProductReport] = useState([]);
    const [customerState, setCustomerState] = useState("");


    let netAmount = 0;
    let quantity = 0;
    let balance = 0;

    const calNetAmount = () => {
        if (ProductReport.length == 0) {
            props.form.setFieldsValue({
                totalAmount: 0,
                balance: 0,
                quantity: 0,

                remainingAmount: 0,
            });
        }
        ProductReport.forEach((y) => {
            let paidAmount = getFieldValue("paidAmount");
            paidAmount = paidAmount ? fixed2Digit(paidAmount) : 0;
            netAmount += Number(y.netAmount);
            quantity += Number(y.quantity);
            balance = paidAmount ? netAmount - paidAmount : netAmount;

            if (balance < 0) {
                balance = "Not valid Paid Amount";

                props.form.setFieldsValue({
                    totalAmount: netAmount ? fixed2Digit(netAmount) : 0,
                    quantity: quantity,
                    balance: 0,
                });
            } else {
                props.form.setFieldsValue({
                    totalAmount: netAmount.toFixed(2),
                    quantity: quantity,
                    balance: balance ? balance.toFixed(2) : 0,
                });
            }
        });
    };

    const fetchBanks = async () => {
        const {data} = await fetchBank({
            type: "bank",
            results: 100,
            count: 100,
        });
        setBanks(data);
    };

    useEffect(() => {
        props.form.setFieldsValue({
            paidAmount: 0,
            paymentType: "None",
            salesDate: moment(),
            creditNoteBalance: 0,
            remainingAmount: 0,
        });

        fetchBanks();
    }, []);

    useEffect(() => {
        if (customerState) {
            props.form.setFieldsValue({
                stateOfSupply: customerState,
            });
        }
    }, [customerState]);


    useEffect(() => {
        calNetAmount();
    }, [ProductReport, getFieldValue("paidAmount")]);

    const handleSubmit = async (e) => {
        const {form} = props;
        e.preventDefault();
        form.validateFields(async (err, valData) => {
            if (!err) {
                valData.customerId = customer._id;
                valData.paidToUser = formData;
                valData.paymentStatus = "Done";
                valData.saleId = saleId;
                if (isNaN(valData.paidAmount)) {
                    notification.warning({
                        message: "Please Enter Paid Amount in Numbers",
                    });
                    return;
                }
                const paidAmount = valData.paidAmount;
                if (paidAmount < 0) {
                    notification.error({
                        message: "Paid Amount cannot be negative",
                    });
                    return;
                }
                if (!valData.paidAmount) {
                    notification.warning({message: "Please Add Amount"});
                    return;
                }
                if (!valData.date) {
                    notification.warning({message: "Please Choose Date"});
                    return;
                }
                const lastData = formData[formData.length - 1];
                if (!lastData.bankId) {
                    notification.warning({message: "Please Choose Bank"});
                    return;
                }
                if (!lastData.paymentType) {
                    notification.warning({message: "Please Choose Payment Type"});
                    return;
                }
                if (!lastData.amount) {
                    notification.warning({message: "Please Enter Amount"});
                    return;
                }
                const sumFormDataAmount = formData.reduce(
                    (sum, item) => sum + parseFloat(item.amount) || 0,
                    0
                );

                if (parseFloat(valData.paidAmount) < sumFormDataAmount) {
                    notification.error({
                        message: "Paid amount cannot be Greater than total amount",
                    });
                    return;
                } else if (parseFloat(valData.paidAmount) > sumFormDataAmount) {
                    notification.error({
                        message: "Paid amount cannot be less than total amount",
                    });
                    return;
                }

                let x = await dispatch(addPaymentInDirectFxn(valData));

                if (x && x.success) {
                    setProductReport([]);
                    props.form.setFieldsValue({
                        paidAmount: "",
                        balance: "",
                        customerId: "",
                        paymentType: "",
                        paymentDetails: "",
                    });
                    setCustomerState("")
                    onSubmit()
                } else {
                    notification.error({message: x.message});
                }
            }
        });
    };

    let inputTypes = {
        lowerFields: [
            {
                key: "paidAmount",
                type: "text",
                label: "Amount",
                span: "col-md-6",
                placeholder: "Amount",
            },
            {
                key: "date",
                label: "Date*",
                type: "date",
                span: "col-md-6",
                onChange: (x) => {
                    props.form.setFieldsValue({
                        date: x,
                    });
                },
                disablePreviousDate: !['company', 'branch', 'headBranch'].includes(checkUserType)
            },
        ],
    };
    const groupType = "SUNDRY DEBTORS";

    return (
        <>
            <Drawer visible={visible} onClose={onClose} title={'Payment IN'} width={'55%'}>
                <Card>
                    <div className={"row"}>
                        <div className={"col-md-6 mb-3"}>
                            <InputBox title={"Client"}>
                                <input
                                    style={{height: "45px", color: "black"}}
                                    disabled
                                    className={"form-control"}
                                    type="text"
                                    value={customer.name}
                                />
                            </InputBox>
                        </div>
                    </div>
                    <Form onSubmit={handleSubmit}>
                        <div className="form-elements-wrapper">
                            <div className={"row"}>
                                {inputTypes.lowerFields.map((item, key) => {
                                    return !item.hidden ? (
                                        <div
                                            className={`pb-3 ${item.span ? item.span : "col-md-6"}`}
                                            key={key}>
                                            <GetEachFormFields {...props.form} item={item}/>
                                        </div>
                                    ) : null;
                                })}
                            </div>

                            {getFieldValue("paidAmount") > 0 ? (
                                <Card title={"Payments (Credit)"} size={"small"}>
                                    <div className="d-flex align-items-end">
                                        {formData.map((data, index) => (
                                            <div key={index} className={"item-flex mt-2"}>
                                                <InputBox title={"Banks"}>
                                                    <select
                                                        style={{height: "45px"}}
                                                        className="form-control"
                                                        value={data.bank}
                                                        onChange={(e) =>
                                                            handleInputChange(
                                                                index,
                                                                "bankId",
                                                                e.target.value
                                                            )
                                                        }
                                                        required="true"
                                                    >
                                                        <option value="">Select Bank</option>
                                                        {banks?.map((bank) => (
                                                            <option key={bank._id} value={bank._id}>
                                                                {bank.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </InputBox>

                                                <InputBox title={"Payment Type"}>
                                                    <select
                                                        style={{
                                                            height: "45px",
                                                        }}
                                                        className="form-control"
                                                        value={data.paymentType}
                                                        required
                                                        onChange={(e) =>
                                                            handleInputChange(
                                                                index,
                                                                "paymentType",
                                                                e.target.value
                                                            )
                                                        }
                                                    >
                                                        <option value="">Select Payment Type</option>
                                                        {PaymentTypes?.map((PaymentTypes) => (
                                                            <option>{PaymentTypes.name}</option>
                                                        ))}
                                                    </select>
                                                </InputBox>

                                                <InputBox title={"Amount"}>
                                                    <input
                                                        style={{
                                                            height: "45px",
                                                        }}
                                                        className={"form-control"}
                                                        type="text"
                                                        value={data.amount}
                                                        onChange={(e) =>
                                                            handleInputChange(
                                                                index,
                                                                "amount",
                                                                e.target.value
                                                            )
                                                        }
                                                        placeholder="Amount"
                                                    />
                                                </InputBox>

                                                <InputBox title={"Transaction Details"}>
                                                    <input
                                                        style={{
                                                            height: "45px",
                                                        }}
                                                        className={"form-control"}
                                                        value={data.transactionDetails}
                                                        onChange={(e) =>
                                                            handleInputChange(
                                                                index,
                                                                "transactionDetails",
                                                                e.target.value
                                                            )
                                                        }
                                                        placeholder="Transaction Details"
                                                    />
                                                </InputBox>
                                                <InputBox className="deleteBtn">
                                                    <div key={index} className={"item-flex mt-3"}>
                                                        {index > 0 &&
                                                            showDeleteButtons[index] && ( // Condition added to not show delete button for zero index
                                                                <a
                                                                    className="empty_btn"
                                                                    onClick={() => handleDelete(index)}
                                                                >
                                                                    <i className="fa fa-trash-alt"/>
                                                                </a>
                                                            )}
                                                    </div>
                                                </InputBox>
                                            </div>
                                        ))}
                                    </div>
                                </Card>
                            ) : null}
                        </div>

                        <button type="submit" className="btn btn-gradient-info me-2">
                            Submit
                        </button>
                        <HyperLink className=" ms-4 btn btn-danger" link={"/sale"}>
                            Cancel
                        </HyperLink>
                    </Form>
                </Card>
            </Drawer>
        </>
    )
}
export default Form.create()(PaymentInDrawer);
